// Generated by python manage.py export_food_types. Edit catalog/food_types.py.
export const FOOD_TYPE_LABELS = {
  "pizza": "Pizza",
  "snack": "Lanche",
  "dish": "Prato / Refeição",
  "savory": "Salgado",
  "portion": "Porção",
  "drink": "Bebida",
  "dessert": "Sobremesa",
  "bakery": "Padaria",
  "confectionery": "Confeitaria",
  "grocery": "Mercado / Mercearia",
  "combo": "Combo",
  "other": "Outro"
} as const;

export type FoodType = keyof typeof FOOD_TYPE_LABELS;

export function getFoodTypeLabel(value?: FoodType): string {
  return value ? FOOD_TYPE_LABELS[value] ?? "Item" : "Item";
}
